import React, { useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import SettingsDrawer from './SettingsDrawer';
import DealsDrawer from "./DealsDrawer";

const ROLE_LABELS = {
  admin: 'Admin',
  sales_head: 'Sales Head',
  team_lead: 'Team Lead',
  sales_manager: 'Sales Manager'
};

const ROLE_BADGE = {
  admin: 'role-admin',
  sales_head: 'role-head',
  team_lead: 'role-teamlead',
  sales_manager: 'role-manager'
};

function NavItem({ to, label, icon }) {
  return (
    <NavLink to={to} className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}>
      {icon}
      {label}
    </NavLink>
  );
}

export default function Layout() {
  const { user, logout } = useAuth();
  const [showDeals, setShowDeals] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const initials =
    user?.name
      ?.split(' ')
      .map(w => w[0])
      .join('')
      .slice(0, 2)
      .toUpperCase() || 'U';

  const isAdmin = user?.role === 'admin';

  const isAdminOrHead = [
    'admin',
    'sales_head'
  ].includes(user?.role);

  const canViewReports = [
  'admin',
  'sales_head',
  'team_lead',
  'sales_manager'
].includes(user?.role);

  return (
    <div className="layout">
      <aside className="sidebar">
        <div className="sidebar-logo">
          <div className="brand">Aranyaka <span>Estates</span></div>
          <div className="tagline">Sales CRM</div>
        </div>

        <nav className="sidebar-nav">

  <div className="nav-section-label">Pipeline</div>

  <NavItem
    to="/pipeline"
    label="Pipeline"
    icon={
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M4 5h16" />
        <path d="M7 10h10" />
        <path d="M10 15h4" />
        <path d="M11 20h2" />
      </svg>
    }
  />

  {isAdminOrHead && (
    <NavItem
      to="/drop"
      label="Drop"
      icon={
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
          <path d="M6 3h12" />
          <path d="M8 3v18l4-3 4 3V3" />
        </svg>
      }
    />
  )}

  <div
    className="nav-item"
    onClick={() => setShowDeals(true)}
    style={{ cursor: "pointer" }}
  >
    💼 Deal
  </div>
          <NavItem to="/leads" label="All Leads" icon={<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>} />
          
          <NavItem to="/leads/add" label="Add Lead" icon={<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/></svg>} />
          <NavItem to="/tasks" label="My Tasks" icon={<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>} />

          {isAdmin && (
  <>
    <div className="nav-section-label">Incoming</div>

    <NavItem
      to="/upload"
      label="CSV Upload"
      icon={
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
        >
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
          <polyline points="17 8 12 3 7 8" />
          <line x1="12" y1="3" x2="12" y2="15" />
        </svg>
      }
    />
    <NavItem
  to="/settings/data-migration"
  label="Data Migration"
  icon={
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
    >
      <path d="M12 3v12" />
      <path d="M8 11l4 4 4-4" />
      <path d="M5 21h14" />
    </svg>
  }
/>

    <NavItem
      to="/sources"
      label="Sources & Webhooks"
      icon={
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
        >
          <path d="M1 6l11 6 11-6" />
          <path d="M1 12l11 6 11-6" />
          <path d="M1 18l11 6 11-6" />
        </svg>
      }
    />
        <NavItem
      to="/export"
      label="Export"
      icon={
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
        >
          <path d="M12 3v12" />
          <path d="M8 11l4 4 4-4" />
          <path d="M5 21h14" />
        </svg>
      }
    />
  </>
)}

          {canViewReports && (
  <>
    <div className="nav-section-label">Manage</div>

    <NavItem
  to="/reports"
  label={user?.role === "sales_manager" ? "My Performance" : "Reports"}
  icon={
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
    >
      <line x1="18" y1="20" x2="18" y2="10" />
      <line x1="12" y1="20" x2="12" y2="4" />
      <line x1="6" y1="20" x2="6" y2="14" />
    </svg>
  }
/>

    {isAdminOrHead && (
      <>
        <NavItem
          to="/team"
          label="Team & Users"
          icon={<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/></svg>}
        />

        
        {isAdmin && (
  <div
    className="nav-item"
    onClick={() => setShowSettings(true)}
    style={{ cursor: "pointer" }}
  >
    ⚙️ Settings
  </div>
)}
      </>
    )}
  </>
)}</nav>

        <div className="sidebar-user">
          <div style={{ display:'flex', alignItems:'center', gap:'9px' }}>
            <div style={{ width:'32px', height:'32px', borderRadius:'50%', background:'rgba(29,158,117,0.2)', color:'#9FE1CB', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'11px', fontWeight:'700', flexShrink:0 }}>{initials}</div>
            <div style={{ flex:1, minWidth:0 }}>
              <div className="sidebar-user-name" style={{ overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{user?.name}</div>
              <div className={`sidebar-user-role-badge ${ROLE_BADGE[user?.role]}`}>{ROLE_LABELS[user?.role]}</div>
            </div>
          </div>
          <button className="sidebar-logout" onClick={handleLogout}>Sign out</button>
        </div>
      </aside>

      <main className="main-content">
        <Outlet />
      </main>
      <DealsDrawer
  open={showDeals}
  onClose={() => setShowDeals(false)}
/>
      <SettingsDrawer
  open={showSettings}
  onClose={() => setShowSettings(false)}
/>
    </div>
  );
}
